<template>
  <span
    class="text-primary cursor-pointer font-medium text-sm -tracking-[0.02rem] hover:underline underline-offset-2 hover:brightness-50"
    ><slot />
  </span>
</template>
